<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">

                <!-- Primeira linha: ID | De | Até | Situação do bem -->
                <b-row>
                    <b-col md="2" sm="6">
                        <lg-form-input v-model="form.numeroId" label="ID:" description="" />
                    </b-col>
                    <b-col md="3" sm="6">
                        <lg-form-date v-model="form.dataDe" label="De:" invalidFeedback=" " description=" " />
                    </b-col>
                    <b-col md="3" sm="6">
                        <lg-form-date v-model="form.dataAte" label="Até:" invalidFeedback=" " description=" " />
                    </b-col>
                    <b-col md="4" sm="6">
                        <lg-form-const-select label="Situação do bem:" v-model="form.situacaoBem"
                            :options="optionsFilterSituacaoBem" @change="load" />
                    </b-col>
                </b-row>

                <!-- Segunda linha: Descrição | Unidade Administrativa -->
                <b-row>
                    <b-col md="5" sm="12">
                        <lg-form-input v-model="form.descricao" label="Descrição:" description="" />
                    </b-col>
                    <b-col md="7" class="px-4" sm="12">
                        <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativa"
                            @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                            invalidFeedback="Informe uma unidade administrativa!" />
                    </b-col>
                </b-row>

                <!-- Terceira linha: Usuário | Situação login | Botões de ação -->
                <b-row class="mt-2 align-items-end px-2">
                    <b-col md="5" sm="12">
                        <lg-finder-page-pessoa id="finderResponsavelTarefa" label="Usuário:"
                            @onselect="handleSelectResponsavelTarefa" v-model="form.usuario"
                            invalidFeedback="Informe um responsável!" :prefix="prefix + title + ' > '" />
                    </b-col>
                    <b-col md="4" sm="8">
                        <lg-form-const-select label="Situação login:" v-model="form.situacaoLogin"
                            :options="optionsFilterSituacaoLogin" @change="load" />
                    </b-col>
                    <!-- Todos os botões de ação juntos à direita -->
                    <b-col md="3" sm="4" class="d-flex justify-content-end align-items-center">
                        <!-- Limpar -->
                        <b-button id="limpar" size="sm" pill variant="primary" class="mx-1" style="height: 40px"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limpar" title="Limpar" />
                        </b-button>
                        <!-- Buscar -->
                        <b-button id="localizar" size="sm" pill variant="primary" class="mx-1" style="height: 40px"
                            @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar" title="Localizar" />
                        </b-button>
                        <!-- Novo -->
                        <b-button v-if="temPrivilegioInclusao()" id="novo" size="sm" pill variant="success" class="mx-1"
                            style="height: 40px" @click="showModalCadastro">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..." />
                        </b-button>
                        <!-- XLSX -->
                        <img @click="gerarRelatorioGeralXlsx()" :src="xlsIcon" alt="XLSX" class="mx-1"
                            style="width:32px;cursor:pointer" v-b-tooltip.hover.top="'Gerar Relatório XLS'" />
                        <!-- PDF -->
                        <img @click="gerarRelatorioGeralPdf()" :src="pdf" alt="PDF" class="mx-1"
                            style="width:32px;cursor:pointer" v-b-tooltip.hover.top="'Gerar Relatório PDF'" />
                    </b-col>
                </b-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(documentos)="{ item }">
                        <b-button :id="'documentos-' + item.id" class="my-2" size="sm" pill variant="primary"
                            @click="abrirModalDocumento(item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="'documentos-' + item.id" title="Documentos de Bem Terceiro"
                                triggers="hover"></b-tooltip>
                        </b-button>
                    </template>


                    <template v-slot:cell(editar)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button'" class="my-2"
                            size="sm" pill variant="primary" @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button'" title="Editar..."></b-tooltip>
                        </b-button>

                    </template>

                    <template v-slot:cell(situacaoLogin)="row">
                        <div :id="row.index + 'switchLogin'">
                            <b-form-checkbox v-model="row.item.situacaoLogin" :disabled="true" switch size="lg"
                                :value="1" :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchLogin'"
                                :title="row.item.situacaoLogin === 1 ? 'Ativo' : 'Inativo'"></b-tooltip>
                        </div>
                    </template>
                    <template v-slot:cell(situacaoBem)="row">
                        <div :id="row.index + 'switchGrupo'">
                            <b-form-checkbox v-model="row.item.situacaoBem" @change="alteraSituacao(row.item)"
                                name="check-button" switch size="lg" :value="1" :unchecked-value="0" />
                            <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
                        </div>
                    </template>
                    <template #cell(relatorioPdf)="row">
                        <div :id="'relatorioPdf-' + row.item.id">
                            <img @click="gerarPdf(row.item)" :src="pdf" class="img img--clickable" alt="PDF" />
                            <b-tooltip :target="'relatorioPdf-' + row.item.id" title="Gerar Etiqueta"></b-tooltip>
                        </div>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <BemTerceiroForm @close="fecharModal" :id="id" :prefix="prefix + title + ' > '" v-if="showModal">
        </BemTerceiroForm>
        <ModalDocumentosBemTerceiro v-if="showModalDocumentos" @close="fecharModal" :id="id"
            :prefix="prefix + title + ' > '" />
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import BemTerceiroForm from "./BemTerceiroForm.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import moment from "moment";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import ModalDocumentosBemTerceiro from "@/core/components/Modals/ModalDocumentosBemTerceiro.vue";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import PdfIcon from "@/core/assets/icons/pdf.png";
import gerarEtiquetaPdf from "@/utils/etiquetaPdf";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
import xlsIcon from "@/core/assets/icons/xls.png";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        LgFormDate,
        LgFinderPageUnidadeAdministrativa,
        LgFinderPagePessoa,
        BemTerceiroForm,
        ModalDocumentosBemTerceiro

    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },
    created() {
        const brand = JSON.parse(localStorage.getItem("context"));
        this.form.departamento = brand.departamento;
    },
    data() {
        return {
            id: null,
            title: 'Bem Terceiro',
            showModal: false,
            showModalDocumentos: false,
            perPage: 10,
            page: 1,
            perPageOptions: [10, 25, 50, 100],
            form: {
                departamento: {},
                usuario: {},
                situacao: 1,
                descricao: "",
                numeroId: "",
                dataDe: "",
                dataAte: "",
                situacaoLogin: 1,
                situacaoBem: 1,
            },
            optionsFilterSituacaoLogin: [
                { key: "filterSituacao", text: "Todos", value: undefined },
                { key: "filterSituacao", text: "Ativo", value: 1 },
                { key: "filterSituacao", text: "Inativo", value: 0 },
            ],

            optionsFilterSituacaoBem: [
                { key: "filterSituacao", text: "Todos", value: undefined },
                { key: "filterSituacao", text: "Ativo", value: 1 },
                { key: "filterSituacao", text: "Inativo", value: 0 },
            ],
            pdf: PdfIcon,
            xlsIcon: xlsIcon
        };
    },
    mixins: [ListResourceMixin, FormResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/bemterceiro`);
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            return [
                { key: "login", label: "Login" },
                { key: "nome", label: "Usuário" },
                { key: "situacaoLogin", label: "Situação Login", tdClass: "text-center", thClass: "text-center" },
                { key: "id", label: "ID" },
                { key: "descricao", label: "Descrição" },
                { key: "situacaoBem", label: "Situação Bem", tdClass: "text-center", thClass: "text-center" },
                {
                    key: "dhCriacao",
                    label: "Data",
                    formatter: d => moment(String(d)).format("DD/MM/YYYY"),
                },
                { key: "documentos", label: " ", tdClass: "w-1" },
                { key: "editar", label: " ", tdClass: "w-1" },
                { key: "relatorioPdf", label: " ", tdClass: "w-1", thClass: "text-center" },
            ];
        },
    },
    methods: {

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.BEM_TERCEIRO_EDITAR);
        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.BEM_TERCEIRO_INCLUIR);
        },
        async gerarPdf(item) {
            try {
                gerarEtiquetaPdf(item);
            } catch (e) {
                console.error(e);
                this.$notify({
                    type: "danger",
                    message: e.response.data,
                });
            }
        },
        async gerarRelatorioGeralPdf() {
            this.param = {};
            if (this.form.departamento && this.form.departamento.id) {
                this.param.departamento = this.form.departamento.id;
            }
            if (this.form.numeroId && this.form.numeroId) {
                this.param.id = this.form.numeroId;
            }
            if (this.form.usuario && this.form.usuario.id) {
                this.param.pessoa = this.form.usuario.id;
            }

            if (this.form.situacaoLogin != null) {
                this.param.situacaoLogin = this.form.situacaoLogin;
            }

            if (this.form.descricao && this.form.descricao.length > 0) {
                this.param.descricao = this.form.descricao;
            }

            if (this.form.situacaoBem != null) {
                this.param.situacao = this.form.situacaoBem;
            }

            if (this.form.dataDe) {
                this.param.dataDe = moment(this.form.dataDe)
                    .format('DD/MM/YYYY');
            }

            if (this.form.dataAte) {
                this.param.dataAte = moment(this.form.dataAte)
                    .format('DD/MM/YYYY');
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-bem-terceiro');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }
        },
        async gerarRelatorioGeralXlsx() {
            this.param = {};
            if (this.form.departamento && this.form.departamento.id) {
                this.param.departamento = this.form.departamento.id;
            }
            if (this.form.numeroId && this.form.numeroId) {
                this.param.id = this.form.numeroId;
            }
            if (this.form.usuario && this.form.usuario.id) {
                this.param.pessoa = this.form.usuario.id;
            }

            if (this.form.situacaoLogin != null) {
                this.param.situacaoLogin = this.form.situacaoLogin;
            }

            if (this.form.descricao && this.form.descricao.length > 0) {
                this.param.descricao = this.form.descricao;
            }

            if (this.form.situacaoBem != null) {
                this.param.situacao = this.form.situacaoBem;
            }

            if (this.form.dataDe) {
                this.param.dataDe = moment(this.form.dataDe)
                    .format('DD/MM/YYYY');
            }
            if (this.form.dataAte) {
                this.param.dataAte = moment(this.form.dataAte)
                    .format('DD/MM/YYYY');
            }

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-bem-terceiro')
                const { data } = await resource.getWithParams('EXCEL', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo)
            } finally {
                this.busy = false
            }
        },
        abrirModalDocumento(item) {
            this.id = item.id;
            this.showModalDocumentos = true;
        },
        handleSelectResponsavelTarefa(pessoa) {
            this.form.usuario = pessoa;
            this.load();
        },
        showModalCadastro(item) {
            if (item)
                this.id = item.id;

            this.showModal = true;
        },
        fecharModal() {
            this.id = null;
            this.showModal = false;
            this.showModalDocumentos = false;
            this.load();
        },
        async editar(item) {
            this.showModalCadastro(item);
        },
        async documentosAnexosRedirect(item) {
            this.$router.push({ path: `${item.id}/anexo`, params: { id: item.id } });
        },
        async load() {
            this.param = {};
            if (this.form.departamento && this.form.departamento.id) {
                this.param.departamento = this.form.departamento.id;
            }
            if (this.form.numeroId && this.form.numeroId) {
                this.param.id = this.form.numeroId;
            }
            if (this.form.usuario && this.form.usuario.id) {
                this.param.pessoa = this.form.usuario.id;
            }

            if (this.form.situacaoLogin != null) {
                this.param.situacaoLogin = this.form.situacaoLogin;
            }

            if (this.form.descricao && this.form.descricao.length > 0) {
                this.param.descricao = this.form.descricao;
            }

            if (this.form.situacaoBem != null) {
                this.param.situacao = this.form.situacaoBem;
            }
            if (this.form.dataDe) {
                this.param.dataDe = moment(this.form.dataDe)
                    .format('DD/MM/YYYY');
            }
            if (this.form.dataAte) {
                this.param.dataAte = moment(this.form.dataAte)
                    .format('DD/MM/YYYY');
            }
            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.param,
            });
        },
        clearForm() {
            this.form.almoxarifado = {};
            this.form.dataAte = "";
            this.form.dataDe = "";
            this.form.descricao = "";
            this.form.numeroId = "";
            this.form.situacaoBem = 1;
            this.form.situacaoLogin = 1;
            this.form.usuario = {};
            this.load();
        },
        async saveBemTerceiro() {
            await this.$service.save(this.form, "listarBemTerceiro");
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacaoBem === 1 ? "ativar" : "desativar") + " o Bem Terceiro?",
                item.descricao.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacaoBem = item.situacaoBem === 1 ? 0 : 1
            }
        },
        async confirmarAlteracaoSituacao(item) {
            item.situacao = item.situacaoBem;
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacaoBem ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacaoBem ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
            this.load();
        },
    },
};
</script>
